"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.similarHotelFactory = similarHotelFactory;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _language = require("../utils/language.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _hotelSummaryCard = require("./hotel-summary-card.factory");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {Object} dynamicContent
 * @param {Object} staticContent
 * @param {String} language
 * @param {String} hotelId
 * @param {String} currency
 * @param {Number} rooms
 * @param {Number} nights
 * @param {Function} formatPrice
 * @return {Object}
 */
function similarHotelFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    id = _ref.hotelId,
    _ref$staticContent = _ref.staticContent,
    staticContent = _ref$staticContent === void 0 ? {} : _ref$staticContent,
    _ref$dynamicContent = _ref.dynamicContent,
    dynamicContent = _ref$dynamicContent === void 0 ? {} : _ref$dynamicContent,
    language = _ref.language,
    rooms = _ref.rooms,
    nights = _ref.nights,
    formatPrice = _ref.formatPrice,
    currency = _ref.currency,
    isPollingCompleted = _ref.isPollingCompleted,
    reviewsScaleOfTen = _ref.reviewsScaleOfTen,
    propertyTypesHashMap = _ref.propertyTypesHashMap;
  var hasStaticContent = !(0, _isEmpty2["default"])(staticContent);
  var isPriceFetched = !(0, _isEmpty2["default"])(dynamicContent);
  var soldOut = hasStaticContent && !isPriceFetched && isPollingCompleted;
  var review = staticContent.review,
    nameObj = staticContent.name,
    addressObj = staticContent.address,
    stars = staticContent.starRating,
    img = staticContent.thumbnailUrl,
    topPicks = staticContent.topPicks,
    similarityScore = staticContent.similarityScore,
    propertyTypeId = staticContent.propertyTypeId;
  var propertyType = (0, _get2["default"])(propertyTypesHashMap[propertyTypeId], 'name', null);
  var score = (0, _get2["default"])(review, 'score', 0);
  var name = (0, _language.translateObjectLabel)(nameObj, language);
  var address = (0, _language.translateObjectLabel)(addressObj, language);
  var topPick = {
    title: (0, _language.translateObjectLabel)((0, _get2["default"])(topPicks, 'categories'), language),
    icon: (0, _get2["default"])(topPicks, 'categories.iconLink')
  };
  var reviews = (0, _hotelSummaryCard.formatHotelReview)({
    staticHotel: staticContent,
    language: language,
    reviewsScaleOfTen: reviewsScaleOfTen
  });
  return _objectSpread({
    soldOut: soldOut,
    id: id,
    name: name,
    score: score,
    rooms: rooms,
    nights: nights,
    address: address,
    stars: stars,
    img: img,
    language: language,
    topPick: topPick,
    similarityScore: similarityScore,
    reviews: reviews,
    propertyType: propertyType
  }, formatRateInfo({
    dynamicContent: dynamicContent,
    formatPrice: formatPrice,
    currency: currency
  }));
}

/**
 * format rate info
 * @param {Object} dynamicContent
 * @param {Function} formatPrice
 * @param {String} currency
 * @return {Object}
 */
function formatRateInfo(_ref2) {
  var dynamicContent = _ref2.dynamicContent,
    formatPrice = _ref2.formatPrice,
    currency = _ref2.currency;
  var originalRate = dynamicContent.firstPrice,
    finalRate = dynamicContent.basePrice,
    perNightOriginalRate = dynamicContent.firstPriceNightlyRate,
    perNightFinalRate = dynamicContent.basePriceNightlyRate,
    discountPercentage = dynamicContent.discountPercentage,
    showDiscount = dynamicContent.showDiscount;
  var discount = showDiscount && discountPercentage > 0 ? discountPercentage : 0;
  if (!finalRate) {
    return {
      rateInfo: null,
      totalRateInfo: null,
      perNightRateInfo: null
    };
  }
  return {
    rateInfo: {
      finalRate: finalRate,
      originalRate: originalRate,
      discount: discount,
      currency: currency
    },
    totalRateInfo: {
      finalRate: formatPrice(finalRate, 0),
      originalRate: formatPrice(originalRate, 0),
      discount: discount,
      currency: currency
    },
    perNightRateInfo: {
      finalRate: formatPrice(perNightFinalRate, 0),
      originalRate: formatPrice(perNightOriginalRate, 0),
      discount: discount,
      currency: currency
    }
  };
}